// extracted by mini-css-extract-plugin
export default {"image-focus-point-cell":"image-focus-point-cell--vwAjB3CS-6","imageFocusPointCell":"image-focus-point-cell--vwAjB3CS-6","active":"active--E0OzJLxn7M"};